import decode from 'jwt-decode';

const hasAuth = (request) => {
    if ((localStorage.getItem('token') !== null) && decode(localStorage.getItem('token')).exp > Date.now() / 1000) {
        return request();
    } else {
        localStorage.clear();
        window.location.replace("/");
    }
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { hasAuth };